import http from '@/http'

export async function allRooms () {
  const data = await http.get('/admin/rooms').then(response => response.data)
  return data.data.map(item => ({
    id: item.id + '',
    name: item.name
  }))
}
